import src from "IMAGE";
export default { src, width: 4241, height: 2393, blurWidth: 0, blurHeight: 0};
